import type { Board } from "../../board";
import { PRIORITY_DEFAULT, type ProcessableThing } from "../../interfaces";
import { Thing } from "../../thing";

export class ThingDestroyedAction extends Thing implements ProcessableThing {
	static key = "ThingDestroyedAction";
	private trackedThing: Thing;
	private action: () => void;

	constructor(trackedThing: Thing, action: () => void = () => {}) {
		super();
		this.trackedThing = trackedThing;
		this.action = action;
	}

	processTurn(board: Board): void {
		if (!this.trackedThing.active) {
			this.action();
			board.removeAtEndOfTurn(this);
		}
	}

	getProcessPriority(): number {
		return PRIORITY_DEFAULT;
	}

	serialize(): Record<string, unknown> {
		return {
			...super.serialize(),
			trackedThingId: this.trackedThing.id,
		};
	}

	static deserialize(_data: any): ThingDestroyedAction {
		return new ThingDestroyedAction(new Thing());
	}
}
